import React from 'react'
import styled from '@emotion/styled'
import { useToggler } from '../../hooks/index'

import DownChevron from '@kbbcomponentlibrary/icon-chevron-down'
import UpChevron from '@kbbcomponentlibrary/icon-chevron-up'
import { fontSize2XSmall, fontWeightBold, grayLight20 } from '../../constants/principles'

export default ({ children, title, fontSize, expanded, border }) => {
  const [showContent, toggleShowContent] = useToggler(expanded)
  return (
    <ContainerDiv border={border}>
      <TitleDiv onClick={toggleShowContent} fontSize={fontSize}>
        {title} {showContent ? <UpChevron colorFill="#000000" size={16} viewBox="0 0 24 24" /> : <DownChevron colorFill="#000000" size={16} viewBox="0 0 24 24" />}
      </TitleDiv>
      <ChildDiv showContent={showContent}>{children}</ChildDiv>
    </ContainerDiv>
  )
}

const ChildDiv = styled.div`
  ${p => !p.showContent && `display:none;`};
`
const ContainerDiv = styled.div`
  padding: 8px 0px;
  border-bottom: ${p => p.border && `1px solid ${grayLight20}`};
  width: 100%;
`
const TitleDiv = styled.div`
  font-size: ${p => p.fontSize || fontSize2XSmall};
  font-weight: ${fontWeightBold};
  cursor: pointer;
`
